import type { AppState } from "@stores/AppState";
import { MODALS } from "../../ui/screens/modals/modal-names";
import type { RoleSummary } from "@stores/rbac/AccessRolesController";

export const editRole = (appState: AppState, roleId: string, roleSummary?: RoleSummary) => {
    const isAdmin = appState.userState?.isCurrentUserAdmin;

    if (!isAdmin) {
        console.warn('Only admins can edit roles');
        return;
    }

    appState.setModal({
        name: MODALS.ROLE_EDIT,
        params: {
            roleId,
            roleSummary
        }
    });
};
